<div class="sport-tree-selection">
  <app-events-group-mobile [pageType]="pageType" [eventsGroupVM]="eventsGroup" [selectionChanged]="updateGroupChanged"></app-events-group-mobile>
</div>
